module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    staticStyle: {
      "top": "0",
      "left": "0",
      "pointer-events": "none"
    }
  }, [_vm._l((_vm.designs), function(design) {
    return [_c('img', {
      staticClass: "background designOverlay",
      attrs: {
        "src": _vm.srcPath(design)
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13418d44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dev-tools/Design-DevTools.vue
// module id = 221
// module chunks = 1